module.exports = __webpack_public_path__ + "98f1217d0b020a85657493e84e326d2a.png";